import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesDashboards() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Operacion", items: [
      { label: "Dashboard Compras", icon: "fas fa-cart-plus", color: "#3b82f6", href: "/DashboardCompras", desc: "Tablero de compras", enabled: !!user.menu_reportes },
      { label: "Dashboard CXP", icon: "fas fa-chart-bar", color: "#6366f1", href: "/DashboardCXP", desc: "Cuentas por pagar", enabled: !!user.menu_reportes },
      { label: "Dashboard Inventarios", icon: "fas fa-tshirt", color: "#8b5cf6", href: "/DashboardInventarios", desc: "Tablero de inventarios", enabled: !!user.menu_reportes },
    ]},
    { section: "Ventas y Cobranza", items: [
      { label: "Dashboard Ventas", icon: "fas fa-signal", color: "#10b981", href: "/DashboardVentas", desc: "Tablero de ventas", enabled: !!user.menu_reportes },
      { label: "Dashboard Cobranza", icon: "fas fa-dollar-sign", color: "#14b8a6", href: "/DashboardCobranza", desc: "Tablero de cobranza", enabled: !!user.menu_reportes },
      { label: "Dashboard Tiendas", icon: "fas fa-store", color: "#06b6d4", href: "/DashboardTiendas", desc: "Tablero de tiendas", enabled: !!user.menu_reportes },
    ]},
    { section: "Finanzas", items: [
      { label: "Dashboard Gastos", icon: "fas fa-hand-holding-usd", color: "#f59e0b", href: "/DashboardGastos", desc: "Tablero de gastos", enabled: !!user.menu_reportes },
      { label: "Balance", icon: "fas fa-chart-line", color: "#6366f1", href: "/Balance", desc: "Balance general", enabled: !!user.menu_reportes },
      { label: "Antiguedad Saldos Por Cobrar", icon: "fas fa-chart-line", color: "#f59e0b", href: "/AntiguedadSaldosPorCobrar", desc: "Saldos por cobrar", enabled: !!user.menu_reportes },
      { label: "Antiguedad Saldos Vencido", icon: "fas fa-chart-line", color: "#ef4444", href: "/AntiguedadSaldosVencido", desc: "Saldos vencidos", enabled: !!user.menu_reportes },
    ]},
  ];
  return (
    <MenuBotones titulo="Dashboards" descripcion="Tableros de control" icono="fas fa-chart-bar" color="#6366f1" secciones={SECCIONES} />
  );
}

export default BotonesDashboards;
